import { Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import clsx from 'clsx';
import ProvisonalDiagnosis from '../../../../phan-he-kham-benh/components/ProvisonalDiagnosis';

type Props = {
    rowClassName?: string;
    containerClassName?: string;
    endRowClassName?: string;
    formName: string;
    isView?: boolean;
};

const ChanDoan = ({
    rowClassName,
    containerClassName,
    endRowClassName,
    formName,
    isView
}: Props) => {
    const { values, errors, touched, setFieldValue } = useFormikContext<any>();

    const [listComorbidity, setListComorbidity] = useState();

    const handleChange = (data: any) => {
        delete data?.comorbidity;
        setFieldValue(`additionalForms.${formName}`, {
            ...values?.additionalForms?.[formName],
            ...data
        });
    };

    return (
        <div
            className={`spaces p-0 ${containerClassName || ''}`}>
            <Row
                className={clsx(
                    'position-relative w-100 spaces px-0 mx-0'
                )}
            >
                <ProvisonalDiagnosis
                    encounterDiagnosisValues={values?.additionalForms?.[formName]}
                    encounterDiagnosisErrors={errors}
                    encounterDiagnosisTouched={touched}
                    listComorbidity={listComorbidity}
                    setListComorbidity={setListComorbidity}
                    onChange={handleChange}
                    handleChangeEncounterDiagnosis={setFieldValue}
                    rowClassName={clsx(rowClassName)}
                    endRowClassName={endRowClassName}
                    hasDiagnosisNonCoded={false}
                    icd10Field='ggtDiagnosis'
                    disabled={isView}
                />
            </Row>
        </div>
    );
};

export default ChanDoan;
